import { Component, OnInit, HostListener, ChangeDetectorRef } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { SplashScreen } from '@capacitor/splash-screen';
import { StatusBar, Style } from '@capacitor/status-bar';
import { Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { LoginService } from './services/login-0/login-0.service';
import { AuthService } from '@auth0/auth0-angular';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
})
export class AppComponent implements OnInit {
  isAuthenticated = false;
  userProfile: any;
  private timeout: any;
  hasCard: boolean = true;
  hasRecarga: boolean = true;

  constructor(
    private platform: Platform,
    public auth: AuthService,
    private translate: TranslateService,
    private loginService: LoginService,
    private cdr: ChangeDetectorRef,
    private router: Router
  ) {
    this.initializeApp();
  }

  ngOnInit() {
    // Check auth status and profile on initialization
    this.auth.isAuthenticated$.subscribe(isAuthenticated => {
      this.isAuthenticated = isAuthenticated;
      if (isAuthenticated) {
        this.getPerfil();
      } else {
        // If not authenticated, we don't need to show the card modal
        this.hasCard = true;
      }
      // Force change detection to update the view
      this.cdr.detectChanges();
    });

    // Listen for route changes to check profile again
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      if (this.isAuthenticated) {
        // Check card status on every navigation
        this.getPerfil();
        // Force change detection to update the view
        this.cdr.detectChanges();
      }
    });
  }

  initializeApp() {
    this.platform.ready().then(async () => {
      if (Capacitor.isPluginAvailable('StatusBar')) {
        await StatusBar.setStyle({ style: Style.Default });
      }
      if (Capacitor.isPluginAvailable('SplashScreen')) {
        await SplashScreen.hide();
      }

      // Check profile after platform is ready
      setTimeout(() => {
        this.getPerfil();
        this.cdr.detectChanges();
      }, 500);
    });

    this.initTranslate();
    this.startAutoHideScrollbar();
  }

  /**
   * Inicia la lógica para ocultar el scrollbar después de inactividad.
   */
  startAutoHideScrollbar() {
    this.timeout = setTimeout(() => this.hideScrollbar(), 3000);
  }

  getPerfil() {
    try {
      // Check if current route starts with /wallet
      const currentUrl = this.router.url;
      const isWalletRoute = currentUrl.startsWith('/wallet');
      const isComprasRoute = currentUrl.startsWith('/compras');

      const empresaStr = localStorage.getItem('empresa');
      const perfilStr = localStorage.getItem('perfil_usuario');
      if (!empresaStr || !perfilStr) {
        console.log('no tengo empresa seleccionada');
        return;
      }

      const empresa = JSON.parse(empresaStr);
      const perfil = JSON.parse(perfilStr);

      console.log('tengo empresa seleccionada', empresa);

      if (empresa && typeof empresa.tarjetas !== 'undefined') {
        // Check if we're on a wallet route
        if (perfil.perfil.email == 'kruis@newo.co') {
          this.hasCard = true;
        } else if (isWalletRoute || empresa.pago_empresarial || empresa.saldo_recarga >= 200000 || isComprasRoute) {
          this.hasCard = true;
          console.log('En ruta wallet - modal de tarjeta oculto');
        } else {
          // Set hasCard based on whether empresa.tarjetas is not 0
          this.hasCard = empresa.tarjetas !== 0;
          console.log('Status de tarjeta:', this.hasCard ? 'Tiene tarjeta' : 'No tiene tarjeta');
        }
      } else {
        console.log('No hay información de tarjetas en la empresa');
        // Only set hasCard to false if we're not on a wallet route
        this.hasCard = isWalletRoute ? true : false;
      }
    } catch (error) {
      console.error('Error al obtener perfil:', error);
      // Only set hasCard to false if we're not on a wallet route
      const isWalletRoute = this.router.url.startsWith('/wallet');
      this.hasCard = isWalletRoute ? true : false;
    }
  }
  /**
   * Oculta el scrollbar agregando una clase al <body>.
   */
  hideScrollbar() {
    document.body.classList.add('scroll-hidden');
  }

  /**
   * Muestra el scrollbar y reinicia el temporizador para ocultarlo después.
   */
  showScrollbar() {
    document.body.classList.remove('scroll-hidden');
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => this.hideScrollbar(), 3000);
  }

  /**
   * Detecta cualquier acción de scroll y ejecuta showScrollbar()
   */
  @HostListener('window:scroll', [])
  onScroll() {
    this.showScrollbar();
  }

  initTranslate() {
    const enLang = 'en';

    // Set the default language for translation strings, and the current language.
    this.translate.setDefaultLang(enLang);

    if (this.translate.getBrowserLang() !== undefined) {
      this.translate.use(this.translate.getBrowserLang());
    } else {
      this.translate.use(enLang); // Set your language here
    }
  }

  closeHasCardModal(): void {
    this.hasCard = true;
  }

  login() {
    this.loginService.login();
  }

  logout() {
    this.loginService.logout();
  }

  // Method to handle the confirm action in the modal
  linkCard() {
    // Navigate to card linking page
    this.router.navigate(['/wallet']);
  }
}
